import $ from "jquery";
import GLightbox from "glightbox";

$(window).on('load', function () {
	const lightbox = GLightbox({
		selector: '.glightbox',
		touchNavigation: true,
		loop: true,
		autoplayVideos: true,
		plyr: {
			config: {
				muted: true // helps autoplay work in all browsers
			}
		}
	});
});